export default __webpack_public_path__ + "static/media/fa-regular-400.0c6f12b9.eot";